import React, { useState } from "react";
import Select from "react-select";
import { Select as TagSelect} from "antd";

import { DatePicker } from "antd";
import { Link } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import { Edit } from "feather-icons-react/build/IconComponents";
// import { all_routes } from "../../../../../Router/all_routes";
// import RefreshIcon from "../../../../../core/common/tooltip-content/refresh";
// import CollapesIcon from "../../../../../core/common/tooltip-content/collapes";
import InvoiceBillTo from "./InvoiceBillTo";
import CommonFooter from "../../../../../core/common/footer/commonFooter";

const NewInvoice = () => {
  // const route = all_routes;
  const [startDate, setStartDate] = useState(new Date("2025-03-26"));
  const [endDate, setEndDate] = useState(new Date("2025-04-10"));
  const [items, setItems] = useState([]);
  const [discount, setDiscount] = useState(0);
  const [adjustment, setAdjustment] = useState(0);
  const [quantityOption, setQuantityOption] = useState("Qty");
  const TermsConditons = {
    details: `1) Warranty : 12 months from date of Installation. The materials are not covered if its failed due to power fluctuation /
accidents / physical damages
2) Incase of any issues with software integration, Perennial Code will provide you an alternate of punches from device.
3) Devices once installed or used will not be taken back (No Refund)`,
  };

  const itemOptions = [
    {
      item: "Billing Software",
      description:
        "Web-based Billing Software, Estimates/Invoices/Sales Reports",
    },
    {
      item: "Accounting Software",
      description: "Advanced accounting solutions for businesses",
    },
  ];

  const addItem = (item) => {
    const newItem = { id: Date.now(), ...item };
    setItems([...items, newItem]);
  };

  const deleteItem = (id) => {
    setItems(items.filter((item) => item.id !== id));
  };
  const calculateSubtotal = () => {
    return items.reduce(
      (total, item) => total + parseFloat(item.amount || 0),
      0
    );
  };

  // Calculate IGST (18%)
  const calculateIGST = (subtotal) => {
    return (subtotal * 18) / 100;
  };

  // Calculate Discount
  const calculateDiscount = (subtotal) => {
    return (subtotal * discount) / 100;
  };

  // Calculate Total
  const calculateTotal = () => {
    const subtotal = calculateSubtotal();
    const discountAmount = calculateDiscount(subtotal);
    const igst = calculateIGST(subtotal);
    return subtotal - discountAmount + igst + adjustment;
  };

  const statusOptions = [
    { value: "draft", label: "Draft" },
    { value: "sent", label: "sent" },
    { value: "open", label: "open" },
    { value: "Revised", label: "Revised" },
    { value: "Declined", label: "Declined" },
    { value: "Accepted", label: "Accepted" },
  ];
  const AssignedOptions = [
    { value: "Venkatesh D", label: "Venkatesh D" },
    { value: "Venkatesh Nama", label: "Venkatesh Nama" },
    { value: "SreePavani Chivukula", label: "SreePavani Chivukula" },
    { value: "Siva", label: "Siva" },
    { value: "Sharma", label: "Sharma" },
    { value: "Pavan Sai", label: "Pavan Sai" },
  ];

  const currencyOptions = [
    { value: "INR", label: "INR Rs." },
    { value: "USD", label: "USD $" },
    { value: "EUR", label: "EUR €" },
    { value: "KSH", label: "KSH " },
  ];

  const discountOptions = [
    { value: "none", label: "No discount" },
    { value: "Before Tax", label: "Before Tax" },
    { value: "After Tax", label: "After Tax" },
  ];

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <nav aria-label="breadcrumb">
            <div className="d-flex justify-content-between align-items-center ms-3">
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to="/crm/Dashboard">
                    <i className="fas fa-home fa-lg" />
                  </Link>
                </li>
                <h4 className="breadcrumb-item mb-0" aria-current="page">
                  New Invoice
                </h4>
              </ol>
              <div
                className="d-flex align-items-center"
                style={{ marginBottom: "-1rem" }}
              >
                <Link to="/crm/invoices" className="btn btn-secondary mb-2">
                  <i className="ti ti-arrow-left me-1"></i>Back
                </Link>
              </div>
            </div>
          </nav>
          <p className="ms-4">Manage your Invoices here</p>
          {/* </div> */}

          <div className=" mt-4">
            <div className="card card-body">
              <form>
                <div className="row">
                  {/* Left Column */}
                  <div className="col-md-6">
                    <div className="row">
                      <div className="mb-3 col-12">
                        <label>Customer</label>
                        <Select
                          options={[]}
                          placeholder="Select related entity"
                        />
                      </div>
                      <hr></hr>
                      <div className="container mt-1">
                        <div className="row">
                          <div className="col-md-6">
                            <Link
                              to="#"
                              className="dropdown-item"
                              data-bs-toggle="offcanvas"
                              data-bs-target="#offcanvasRightAddress"
                              aria-controls="#offcanvasRightAddress"
                            >
                              <Edit className="info-img me-1" />
                              Bill To
                            </Link>
                            <div className="border p-2 ">
                              <p className="mb-0">Habsiguda,Telangana</p>
                              <p className="mb-0">Hyderabad,TS</p>
                              <p className="mb-0">IND, --</p>
                            </div>
                          </div>
                          <div className="col-md-6 mb-3">
                            <Link
                              to="#"
                              className="dropdown-item"
                              data-bs-toggle="offcanvas"
                              data-bs-target="#offcanvasRightViewJobCard"
                              aria-controls="#offcanvasRightViewJobCard"
                            >
                              Ship To
                            </Link>
                            <div className="border p-2 bg-white rounded">
                              <p className="mb-0">--</p>
                              <p className="mb-0">--, --</p>
                              <p className="mb-0">--, --</p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="mb-3 col-12">
                        <label>Invoice No</label>
                        <div className="input-group">
                          <span className="input-group-text" id="basic-addon1">
                            INV - 2025 /
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Invoice"
                            aria-label="Username"
                            aria-describedby="basic-addon1"
                          />
                        </div>
                      </div>

                      <div className="mb-3 col-6">
                        <label>Invoice Date</label>
                        <DatePicker
                          selected={startDate}
                          onChange={(date) => setStartDate(date)}
                          className="form-control"
                        />
                      </div>

                      <div className="mb-3 col-6">
                        <label>Due Date</label>
                        <DatePicker
                          selected={endDate}
                          onChange={(date) => setEndDate(date)}
                          className="form-control"
                        />
                      </div>

                      {/* <div className="mb-3 col-6">
                        <label>Currency</label>
                        <Select
                          options={currencyOptions}
                          defaultValue={currencyOptions[0]}
                        />
                      </div>

                      <div className="mb-3 col-6">
                        <label>Discount Type</label>
                        <Select
                          options={discountOptions}
                          defaultValue={discountOptions[0]}
                        />
                      </div>

                      <div className="mb-3 col-12">
                        <label>Admin Note</label>
                        <textarea
                          className="form-control"
                          placeholder="Enter bank details"
                        ></textarea>
                      </div>
                       */}
                    </div>
                  </div>

                  {/* Divider */}
                  <div className="col-md-1 d-flex align-items-center justify-content-center">
                    <div
                      style={{
                        width: "1px",
                        backgroundColor: "#ccc",
                        height: "100%",
                      }}
                    />
                  </div>

                  {/* Right Column */}
                  <div className="col-md-5">
                    <div className="row">
                     <div className="d-flex justify-content-start align-items-center mb-2">
                                   <i className="fas fa-tag"></i>
                                   <p className="mb-0 me-2">Tags</p>
                                 </div>
                                 <div className="mb-3 row">
                                   <div className="d-flex align-items-center">
                                     <TagSelect
                                       mode="tags"
                                       style={{
                                         width: "100%",
                                       }}
                                       placeholder="Tags Mode"
                                       size="large"
                                       options={[
                                         { value: "John Doe" },
                                         { value: "Jane Smith" },
                                         { value: "Alice Johnson" },
                                         { value: "Bob Brown" },
                                       ]}
                                     />
                                   </div>
                                 </div>

                      <div className="mb-3 col-12">
                        <label>Allowed Payment Mode for this Invoice</label>
                        <Select
                          options={statusOptions}
                          defaultValue={statusOptions[0]}
                        />
                      </div>
                      <div className="mb-3 col-6">
                        <label>Currency</label>
                        <Select
                          options={currencyOptions}
                          defaultValue={currencyOptions[0]}
                        />
                      </div>
                      <div className="mb-3 col-6">
                        <label>Sale Agent</label>
                        <Select
                          options={AssignedOptions}
                          defaultValue={AssignedOptions[0]}
                        />
                      </div>
                      <div className="mb-3 col-6">
                        <label>Recurring Invoice</label>
                        <Select options={""} defaultValue={"No"} />
                      </div>
                      <div className="mb-3 col-6">
                        <label>Discount Type</label>
                        <Select
                          options={discountOptions}
                          defaultValue={discountOptions[0]}
                        />
                      </div>

                      <div className="mb-3 col-12">
                        <label>Admin Note</label>
                        <textarea
                          className="form-control"
                          placeholder="Enter Address"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </div>
                <hr></hr>
                <div className="row">
                  {/* Dropdown for selecting item */}
                  <div className="dropdown mb-3 col-6">
                    <button
                      className="btn btn-primary dropdown-toggle"
                      data-bs-toggle="dropdown"
                    >
                      Select Item
                    </button>
                    <ul className="dropdown-menu">
                      {itemOptions.map((option, index) => (
                        <li key={index}>
                          <button
                            className="dropdown-item"
                            onClick={(e) => {
                              e.preventDefault();
                              const newItem = {
                                item: option.item,
                                description: option.description,
                                hsn: "",
                                qty: "",
                                rate: "",
                                tax: "9.00%", // Default tax
                                amount: 0, // Default amount
                              };
                              addItem(newItem);
                            }}
                          >
                            {option.item}
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>

                  {/* Radio buttons to switch quantity display */}
                  <div className="d-flex justify-content-end col-6">
                    <fieldset>
                      <label>
                        <b>Show quantity as:</b>
                      </label>
                      <div className="form-check ms-2 form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="quantityOptions"
                          id="qty"
                          value="Qty"
                          checked={quantityOption === "Qty"}
                          onChange={() => setQuantityOption("Qty")}
                        />
                        <label className="form-check-label" htmlFor="qty">
                          Qty
                        </label>
                      </div>
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="quantityOptions"
                          id="hours"
                          value="Hours"
                          checked={quantityOption === "Hours"}
                          onChange={() => setQuantityOption("Hours")}
                        />
                        <label className="form-check-label" htmlFor="hours">
                          Hours
                        </label>
                      </div>
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="quantityOptions"
                          id="qtyHours"
                          value="Qty/Hours"
                          checked={quantityOption === "Qty/Hours"}
                          onChange={() => setQuantityOption("Qty/Hours")}
                        />
                        <label className="form-check-label" htmlFor="qtyHours">
                          Qty/Hours
                        </label>
                      </div>
                    </fieldset>
                  </div>

                  {/* Table to display items */}
                  <div className="table-responsive mt-4">
                    <table className="table table-bordered">
                      <thead className="table-light">
                        <tr>
                          <th>Item</th>
                          <th>Description</th>
                          <th>HSN</th>
                          <th>
                            {quantityOption === "Qty" && "Qty"}
                            {quantityOption === "Hours" && "Hours"}
                            {quantityOption === "Qty/Hours" && "Qty/Hours"}
                          </th>
                          <th>Rate</th>
                          <th>Tax</th>
                          <th>Total</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {items.length === 0 ? (
                          <tr>
                            <td colSpan="8" className="text-center">
                              No data available
                            </td>
                          </tr>
                        ) : (
                          items.map((item) => {
                            const quantity =
                              quantityOption === "Hours"
                                ? item.hours
                                : item.qty;
                            const total = (quantity || 0) * (item.rate || 0);
                            const taxAmount =
                              (total * parseFloat(item.tax)) / 100;
                            const rowTotal = total + taxAmount;

                            return (
                              <tr key={item.id}>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={item.item}
                                    readOnly
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={item.description}
                                    readOnly
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={item.hsn}
                                    onChange={(e) =>
                                      setItems(
                                        items.map((i) =>
                                          i.id === item.id
                                            ? { ...i, hsn: e.target.value }
                                            : i
                                        )
                                      )
                                    }
                                  />
                                </td>
                                <td>
                                  {quantityOption === "Qty" ||
                                  quantityOption === "Qty/Hours" ? (
                                    <input
                                      type="number"
                                      className="form-control"
                                      value={item.qty}
                                      onChange={(e) =>
                                        setItems(
                                          items.map((i) =>
                                            i.id === item.id
                                              ? { ...i, qty: e.target.value }
                                              : i
                                          )
                                        )
                                      }
                                    />
                                  ) : quantityOption === "Hours" ? (
                                    <input
                                      type="number"
                                      className="form-control"
                                      value={item.hours}
                                      onChange={(e) =>
                                        setItems(
                                          items.map((i) =>
                                            i.id === item.id
                                              ? { ...i, hours: e.target.value }
                                              : i
                                          )
                                        )
                                      }
                                    />
                                  ) : null}
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    className="form-control"
                                    value={item.rate}
                                    onChange={(e) =>
                                      setItems(
                                        items.map((i) =>
                                          i.id === item.id
                                            ? { ...i, rate: e.target.value }
                                            : i
                                        )
                                      )
                                    }
                                  />
                                </td>
                                <td>
                                  <select
                                    className="form-control"
                                    value={item.tax}
                                    onChange={(e) =>
                                      setItems(
                                        items.map((i) =>
                                          i.id === item.id
                                            ? { ...i, tax: e.target.value }
                                            : i
                                        )
                                      )
                                    }
                                  >
                                    <option>9.00%</option>
                                    <option>8.00%</option>
                                  </select>
                                </td>
                                <td>{rowTotal.toFixed(2)}</td> {/* Row total */}
                                <td>
                                  <button
                                    className="btn btn-danger"
                                    onClick={() => deleteItem(item.id)}
                                  >
                                    <i className="fas fa-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* Subtotal, Discount, IGST, and Total */}
                  <div className="row mt-3">
                    <div className="col-md-6"></div>
                    <div className="col-md-6">
                      <div className="mb-1">
                        <div className="d-flex justify-content-between">
                          <span>Sub Total:</span>
                          <span>Rs.{calculateSubtotal().toFixed(2)}</span>
                        </div>
                        <hr />
                      </div>

                      <div className="mb-1">
                        <div className="d-flex justify-content-between">
                          <span>Discount:</span>
                          <div className="d-flex" style={{ width: "40%" }}>
                            <select
                              className="form-select"
                              value={discount}
                              onChange={(e) =>
                                setDiscount(parseInt(e.target.value))
                              }
                            >
                              <option value="0">0%</option>
                              <option value="5">5%</option>
                              <option value="10">10%</option>
                              <option value="15">15%</option>
                              <option value="20">20%</option>
                            </select>
                          </div>
                          <span>
                            -Rs.
                            {calculateDiscount(calculateSubtotal()).toFixed(2)}
                          </span>
                        </div>
                        <hr />
                      </div>

                      <div className="mb-1">
                        <div className="d-flex justify-content-end">
                          IGST: (18%)
                          <strong>
                            {" "}
                            Rs.{calculateIGST(calculateSubtotal()).toFixed(2)}
                          </strong>
                        </div>
                        <hr />
                      </div>

                      <div className="mb-1">
                        <div className="d-flex justify-content-between">
                          <span>Adjustment:</span>
                          <div style={{ width: "40%" }}>
                            <input
                              type="number"
                              className="form-control ms-1"
                              value={adjustment}
                              onChange={(e) =>
                                setAdjustment(parseFloat(e.target.value))
                              }
                            />
                          </div>
                          <span>Rs.{adjustment.toFixed(2)}</span>
                        </div>
                        <hr />
                      </div>

                      <div className="mb-1">
                        <div className="d-flex justify-content-end">
                          <strong>Total:</strong>
                          <strong> Rs.{calculateTotal().toFixed(2)}</strong>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr></hr>

                <div className="mb-3 col-12">
                  <label>Client Note</label>
                  <textarea
                    className="form-control"
                    value="Payment Terms : 100% Advance for Hardware"
                  ></textarea>
                </div>
                <div className="mb-3 col-12">
                  <label>Terms and Conditions</label>
                  <textarea
                    className="form-control"
                    cols={3}
                    placeholder=""
                    value={TermsConditons.details}
                  ></textarea>
                </div>
                <div className=" d-sm-flex align-items-center justify-content-end border-top bg-white p-3">
                  <p className="mb-0 text-gray-9"></p>
                  <button type="submit" className="btn btn-info me-2">
                    Save & Send
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <InvoiceBillTo />
        <CommonFooter />
      </div>
    </>
  );
};

export default NewInvoice;
